module.exports = __webpack_public_path__ + "static/media/villa-branco-3.d0a08117.png";